import script from "./OperationsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./OperationsList.vue?vue&type=script&setup=true&lang=ts"

import "./OperationsList.vue?vue&type=style&index=0&id=1055c45d&lang=css"

const __exports__ = script;

export default __exports__